/* Shared physical-size contract. Labels are a fallback, never verified frame measurements. */
(function (root) {
  'use strict';
  function unit(value) {
    value = String(value || '').toLowerCase();
    return /^(in|inch|inches|"|″)$/.test(value) ? 'in' : /^(cm|mm)$/.test(value) ? value : null;
  }
  function number(value) {
    return value.trim().split(/\s+/).reduce(function (sum, part) {
      var fraction = part.split('/');
      return sum + (fraction.length === 2 ? Number(fraction[0]) / Number(fraction[1]) : Number(part));
    }, 0);
  }
  function parse(value, defaultUnit) {
    var text = String(value || '').replace(/,/g, '.').replace(/[”″]/g, '"');
    if (/digital|download|pixels|\bpx\b/i.test(text)) return null;
    var n = '(\\d+\\s+\\d+\\/\\d+|\\d+\\/\\d+|\\d+(?:\\.\\d+)?)';
    var pattern = new RegExp('(?:^|[^\\d.\\/-])' + n + '\\s*(mm|cm|inches|inch|in|\")?\\s*(?:x|×|by)\\s*' + n + '\\s*(mm|cm|inches|inch|in|\")?(?![a-z\\d.\\/])', 'i');
    var match = text.match(pattern);
    if (!match) return null;
    var firstUnit = unit(match[2] || match[4] || defaultUnit);
    var secondUnit = unit(match[4] || match[2] || defaultUnit);
    if (!firstUnit || !secondUnit) return null;
    var factors = { in: 2.54, cm: 1, mm: .1 };
    var widthCm = number(match[1]) * factors[firstUnit], heightCm = number(match[3]) * factors[secondUnit];
    if (!Number.isFinite(widthCm) || !Number.isFinite(heightCm) || widthCm <= 0 || heightCm <= 0) return null;
    return { widthCm: widthCm, heightCm: heightCm, widthIn: widthCm / 2.54, heightIn: heightCm / 2.54, ratio: widthCm / heightCm, source: 'label', verified: false, label: text.trim(), raw: String(value || '') };
  }
  function project(dimensions, scene, widthPx, heightPx) {
    if (!dimensions || !scene || !(widthPx > 0 && heightPx > 0 && scene.referenceCm > 0 && scene.referenceFraction > 0 && scene.referenceFraction <= 1)) return null;
    var pixelsPerCm = (scene.axis === 'height' ? heightPx : widthPx) * scene.referenceFraction / scene.referenceCm;
    var width = dimensions.widthCm * pixelsPerCm, height = dimensions.heightCm * pixelsPerCm;
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
    return { width: width, height: height, estimated: scene.estimated !== false, exceedsScene: width > widthPx || height > heightPx };
  }
  var api = { parse: parse, project: project };
  root.CADimensions = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window === 'undefined' ? globalThis : window);
